/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseMultiFileFieldDisplayType = {
    Box: 'MULTI_FILE_FIELD_BOX',
    List: 'MULTI_FILE_FIELD_LIST'
} as const;
export type DatabaseMultiFileFieldDisplayType = typeof DatabaseMultiFileFieldDisplayType[keyof typeof DatabaseMultiFileFieldDisplayType];


export function DatabaseMultiFileFieldDisplayTypeFromJSON(json: any): DatabaseMultiFileFieldDisplayType {
    return DatabaseMultiFileFieldDisplayTypeFromJSONTyped(json, false);
}

export function DatabaseMultiFileFieldDisplayTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseMultiFileFieldDisplayType {
    return json as DatabaseMultiFileFieldDisplayType;
}

export function DatabaseMultiFileFieldDisplayTypeToJSON(value?: DatabaseMultiFileFieldDisplayType | null): any {
    return value as any;
}

